import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import TotalChart from "../TotalChart";
import Filter from "./Filter";
import useChartOrderContainer from "./useChartOrderContainer";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { Filter1, Filter2 } from "@mui/icons-material";
import { FilterIcon } from "lucide-react";
import { useState } from "react";
import ChartRenderer from "./ChartRenderer";
import TabChartFilter from "../components/TabChartFilter";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterHandler from "../components/FilterHandler";

function OrderChart() {
  const theme = useTheme().palette.mode;

  const {
    dataLineChart,
    chartFilter,
    activeFilterType,
    changeActiveFilterType,
    total,
    designerFiled,
    setDesignerFiled,
    customerFieldValue,
    setCustomerFieldValue,
    tabHandler,
    year,
    setYear,
    month,
    setMonth,
  } = useChartOrderContainer();
  const deviceType = useDeviceType();

  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "orderChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  return (
    <>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box>
              <Button
                onClick={() => changeActiveFilterType(1)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 1
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                {" "}
                تعداد تولیدشده
              </Button>
              <Button
                onClick={() => changeActiveFilterType(2)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 2
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                {" "}
                مساحت تولیدشده
              </Button>
              <Button
                onClick={() => changeActiveFilterType(3)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 3
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                تعداد ثبت شده
              </Button>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "40%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"سفارشات"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                />
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  marginTop: "12px",
                  marginBottom: "8px",
                  padding: "8px",
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <Filter
                  setFieldValue={setCustomerFieldValue}
                  designerFiled={designerFiled}
                  setDesignerFiled={setDesignerFiled}
                  chartFilter={chartFilter}
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
              </Box>
            </Fade>
          )}
          <ChartRenderer dataLineChart={dataLineChart} />

          <Box
            display={"flex"}
            sx={{
              textAlignLast: "center",
            }}
          >
            {deviceType != "mobile" && <TotalChart total={total} size={12} />}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            minWidth: 200,
          }}
        >
          <TitleChart label={"سفارشات"} chartKey={chartKey} />
        </Box>
      )}
    </>
  );
}

export default OrderChart;
